export default __webpack_public_path__ + "static/media/recruitment-layer-0.ef40c753.png";